// Helm variable to determine if in Prod environment
import { PROD_EXEMPTIONS } from '../../config';

// Production Exemption Values
const prodExemptions = [
  { name: 'Charitable Organization', id: 57 },
  { name: 'United Nations/Diplomat', id: 63 },
  { name: 'Federal Government', id: 62 },
  { name: 'Industrial Production/Manufacturing', id: 64 },
  { name: 'Research and Development', id: 85 },
  { name: 'State/Local Government', id: 100 },
  { name: 'Agriculture Production', id: 56 },
  { name: 'Direct Payment', id: 61 },
  { name: 'Educational Institution', id: 97 },
  { name: 'Hospital (Nonprofit or State)', id: 66 },
  { name: 'Nonprofit Religious Organization', id: 99 },
  { name: 'Resale', id: 71 },
];

// Staging / Sandbox Exemption Values
const stageExemptions = [
  { name: 'Charitable Organization', id: 56 },
  { name: 'United Nations/Diplomat', id: 62 },
  { name: 'Federal Government', id: 61 },
  { name: 'Industrial Production/Manufacturing', id: 63 },
  { name: 'Research and Development', id: 84 },
  { name: 'State/Local Government', id: 99 },
  { name: 'Agriculture Production', id: 55 },
  { name: 'Direct Payment', id: 60 },
  { name: 'Educational Institution', id: 96 },
  { name: 'Hospital (Nonprofit or State)', id: 65 },
  { name: 'Nonprofit Religious Organization', id: 56 },
  { name: 'Resale', id: 70 },
];

export const exemptions = PROD_EXEMPTIONS ? prodExemptions : stageExemptions;

export const states = [
  { name: 'Alabama', id: 141 },
  { name: 'Alaska', id: 140 },
  { name: 'Arizona', id: 138 },
  { name: 'Arkansas', id: 137 },
  { name: 'California', id: 136 },
  { name: 'Colorado', id: 135 },
  { name: 'Connecticut', id: 134 },
  { name: 'Delaware', id: 133 },
  { name: 'District Of Columbia', id: 132 },
  { name: 'Florida', id: 131 },
  { name: 'Georgia', id: 130 },
  { name: 'Hawaii', id: 128 },
  { name: 'Idaho', id: 127 },
  { name: 'Illinois', id: 126 },
  { name: 'Indiana', id: 125 },
  { name: 'Iowa', id: 124 },
  { name: 'Kansas', id: 123 },
  { name: 'Kentucky', id: 122 },
  { name: 'Louisiana', id: 121 },
  { name: 'Maine', id: 120 },
  { name: 'Maryland', id: 119 },
  { name: 'Massachusetts', id: 118 },
  { name: 'Michigan', id: 117 },
  { name: 'Minnesota', id: 116 },
  { name: 'Mississippi', id: 115 },
  { name: 'Missouri', id: 114 },
  { name: 'Montana', id: 113 },
  { name: 'Nebraska', id: 112 },
  { name: 'Nevada', id: 111 },
  { name: 'New Hampshire', id: 110 },
  { name: 'New Jersey', id: 109 },
  { name: 'New Mexico', id: 108 },
  { name: 'New York', id: 107 },
  { name: 'North Carolina', id: 106 },
  { name: 'North Dakota', id: 105 },
  { name: 'Ohio', id: 103 },
  { name: 'Oklahoma', id: 102 },
  { name: 'Oregon', id: 101 },
  { name: 'Pennsylvania', id: 100 },
  { name: 'Rhode Island', id: 98 },
  { name: 'South Carolina', id: 97 },
  { name: 'South Dakota', id: 96 },
  { name: 'Tennessee', id: 95 },
  { name: 'Texas', id: 94 },
  { name: 'Utah', id: 92 },
  { name: 'Vermont', id: 91 },
  { name: 'Virginia', id: 90 },
  { name: 'Washington', id: 89 },
  { name: 'West Virginia', id: 88 },
  { name: 'Wisconsin', id: 87 },
  { name: 'Wyoming', id: 86 },
];
